import React from "react";
import {findDOMNode} from "react-dom";
import Classes from "classnames";
import Popover from "../../../../../gd-components/gd-popover/popover";
import {FieldPopoverProps} from "../../../../proto/types";



export default function FieldStoryPoints_Popover(props:FieldPopoverProps) {

    const onSelect = (value:any) => props.parent.onValueChange(value);
    const onCustomize = () => {
        props.parent.hidePopover();
        gd.modules.storyPoints.goToSettings()
    };

    const options = gd.session.companies.get(gd.companyId).settings.fields.storyPoints;
    const isManager = gd.ac.check.company.isManager(gd.companyId);

    return (
        <Popover attachment="top center"
                 targetAttachment="bottom center"
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>
            <div className={Classes("ui5-popover-selector", "cards-selector", {"with-help": isManager})}>
                <div className="ui5-title-tiny popover-title">Story points</div>
                <div className="cards">
                    {_.map(options, (option, key)=>
                        <div key={key}
                             className={Classes("ui5-story-points", "s-40", "m-r-15", "m-b-15", {selected: props.value === option.value})}
                             onClick={()=>{onSelect(option.value)}}>
                            {option.label}
                        </div>)}
                    <div className="ui5-story-points s-40 m-r-15 m-b-15 not-set" onClick={()=>{onSelect(null)}}/>
                </div>

                {isManager &&
                    <div className="help">
                        <div className="ui5-link-small" onClick={onCustomize}>Customize</div>
                    </div>}
            </div>
        </Popover>
    )
}
